// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { omitKeys } from "@hex-insights/core";
import { MarkValue, ReportCard, ReportCardSection, ReportCardSectionPolicy, User } from "../../../Utilities";
import { ReportCardSectionLearningObjectiveFormValues } from "../ReportCardSectionLearningObjective";

export type Base = {
	comment: ReportCardSection["comment"];
	generalComment1: ReportCardSection["generalComment1"];
	generalComment2: ReportCardSection["generalComment2"];
	isComplete: ReportCardSection["isComplete"];
	overallMarkValueID: MarkValue["id"] | null;
	reportCardID: ReportCard["id"] | null;
	reportCardSectionPolicyID: ReportCardSectionPolicy["id"] | null;
};

export type Create = Base & {
	reportCardSectionLearningObjectives: ReportCardSectionLearningObjectiveFormValues.CreateInReportCardSection[];
};

export type CreateRequiredKey = Extract<keyof Create, "reportCardID" | "reportCardSectionPolicyID">;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	comment: "",
	generalComment1: "",
	generalComment2: "",
	isComplete: false,
	overallMarkValueID: null,
	reportCardID: null,
	reportCardSectionLearningObjectives: [],
	reportCardSectionPolicyID: null,
};

export type Detail = Base & {
	submittingUserID: User["id"] | null;
};

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;

export type CreateInReportCard = Omit<Create, "reportCardID">;

export type CreateInReportCardRequiredKey = Exclude<CreateRequiredKey, "reportCardID">;

export type CreateInReportCardSubset<K extends keyof CreateInReportCard = keyof CreateInReportCard> = Pick<
	CreateInReportCard,
	CreateInReportCardRequiredKey | K
>;

export const blankItemInReportCard: CreateInReportCard = omitKeys(initialCreate, ["reportCardID"]);
